import ScrollMagic from 'scrollmagic'
import 'debug.addIndicators'

export const controller = new ScrollMagic.Controller({
  container: window,
});

export const debug = false;



// WEBPACK FOOTER //
// ./scripts/util/scrollmagic.js